import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import "register/less/attribute.less"
import "register/less/password.less"
import "register/less/registration.less"
import Field from "shared/components/forms/field"

const PasswordComponent = (props) => {

    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [isValidPassword, setIsValidPassword] = useState(false)
    const [isValidLength, setIsValidLength] = useState(false)
    const [isTouched, setIsTouched] = useState(false)
    const [containsNumber, setContainsNumber] = useState(false)
    const [containsSpace, setContainsSpace] = useState(false)
    const { t } = useTranslation()
    const validationMessageClasses = "filter-title validation-message"

    useEffect(() => {
        if (props.highlightErrors) {
            setIsTouched(true)
        }
    }, [props.highlightErrors])

    const evaluatePasswordValidity = (text) => {
        let valid = text.length != 0
        if (text.length < 8) {
            valid = false
            setIsValidLength(false)
        } else {
            setIsValidLength(true)
        }
        if (text.length > 32) {
            valid = false
        }
        const regex = new RegExp(/\d+/)
        const regexSpace=new RegExp(/\s/)
        const containsRegexNumber=text.match(regex)
        const containsRegexSpace=text.match(regexSpace)
        if (containsRegexNumber === null) {
            setContainsNumber(false)
        } else {
            setContainsNumber(true)
        }
        if (containsRegexSpace === null) {
          setContainsSpace(false)
        } else {
          setContainsSpace(true)
        }
        valid = containsRegexNumber === null || containsRegexSpace!=null ? false : valid
        setIsValidPassword(valid)
    }

    const evaluateConfirmPasswordValidity = (value) => {
        if (password.length != 0) {
            let valid = password == value && isValidPassword
            props.setPassword(previousState => {
                previousState.value = password
                previousState.valid = valid
                return previousState
            })
            return valid
        }
        return false
    }

    const showErrorMessage = () => {
        return password.length != 0 && password != confirmPassword
    }

    const getFirstPasswordStrengthClass = () => {
        let className = "password-strength"
        if (!isValidLength && containsNumber || isValidLength && !containsNumber) {
            className = `${className} weak-background-color`
        }
        if (isValidLength && containsNumber) {
            className = `${className} good-background-color`
        }
        return className
    }
    const getSecondPasswordStrengthClass = () => {
        let className = "password-strength"
        if (isValidLength && containsNumber) {
            className = `${className} good-background-color`
        }
        return className
    }
    const getThirdPasswordStrengthClass = () => {
        let className = "password-strength"
        if (isValidLength && containsNumber && password.length > 12) {
            className = `${className} good-background-color`
        }
        return className
    }
    const getStrengthColor = () => {
        let className = "strength-string weak-color"
        if (isValidLength && containsNumber) {
            className = "strength-string good-color"
        }
        return className
    }
    const getPasswordStrengthString = () => {
        let strengthString = ''
        if (!isValidLength && containsNumber || isValidLength && !containsNumber) {
            strengthString = t('form.pass_word_strength_weak')
        }
        if (isValidLength && containsNumber) {
            strengthString = t('form.pass_word_strength_medium')
        }
        if (isValidLength && containsNumber && password.length > 12) {
            strengthString = t('form.pass_word_strength_strong')
        }
        return strengthString
    }
    const getPasswordClass = () => {
        let classes = "input-choice"
        if (isTouched && !isValidPassword) {
            classes = `${classes} input-choice-error`
        }
        return classes
    }

    return (
        <div>
            <div className="attribute-container center-items-password">
                <Field
                    placeholder={""}
                    type="password"
                    label={t("user.pass_word")}
                    name="Password"
                    className={getPasswordClass()}
                    value={password}
                    onChange={({ target: { value } }) => {
                        setPassword(value)
                        setIsTouched(true)
                        evaluatePasswordValidity(value)
                    }}
                />
                {isValidPassword && (
                    <i className="im-check check-icon" />
                )}
            </div>
            <div className="center-items">
                <div className="password-strength-container">
                    <span className="strength">{t("form.pass_word_strength")}</span>
                    <div className={getFirstPasswordStrengthClass()}></div>
                    <div className={getSecondPasswordStrengthClass()}></div>
                    <div className={getThirdPasswordStrengthClass()}></div>
                    <div className={getStrengthColor()}>{getPasswordStrengthString()}</div>
                </div>
                {isTouched && password.length == 0 &&
                    <div className={`${validationMessageClasses} attribute-error-message`}>{t("form.pass_word_required")}
                    </div>
                }
                { containsSpace &&
                    <div className={`${validationMessageClasses} attribute-error-message`}>{t("form.pass_space")}
                    </div>
                    }
                <div className={!isValidLength && isTouched ? `${validationMessageClasses} attribute-error-message` : validationMessageClasses}>{t("form.pass_word_length")}
                    {isValidLength && (
                        <i className="im-check check-strength-icon" />
                    )}
                </div>
                <div className={!containsNumber && isTouched ? `${validationMessageClasses} attribute-error-message` : validationMessageClasses}>{t("form.pass_word_number")}
                    {containsNumber && (
                        <i className="im-check check-strength-icon" />
                    )}
                </div>
            </div>
            <div className={"attribute-container center-items"}>
                <Field
                    placeholder={""}
                    name="Confirm Password"
                    type="password"
                    label={t("form.confirm_pass_word")}
                    className={showErrorMessage() ? "input-choice input-choice-error" : "input-choice"}
                    value={confirmPassword}
                    onChange={({ target: { value } }) => {
                        setConfirmPassword(value)
                        evaluateConfirmPasswordValidity(value)
                    }}
                />
                {evaluateConfirmPasswordValidity(confirmPassword) && (
                    <i className="im-check check-icon" />
                )}
                {showErrorMessage() && (
                    <p className="attribute-error-message attribute-error-message-text">{t("form.confirm_pass_word_mismatch")}</p>
                )}
            </div>
        </div>
    )
}

export default PasswordComponent